export default "__VITE_ASSET__CRrGtzG0__"